// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a[data-v-7d00ea52]{fill:none;stroke:#000;stroke-width:1.5px}svg[data-v-7d00ea52]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
